import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b82bfd9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "dataMapper" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { id: "screen-one" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { id: "screen-two" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-2 mb-3" }, null, -1))
const _hoisted_8 = { class: "loader-div-40" }
const _hoisted_9 = ["src"]

import { ElButton, ElScrollbar, ElTag } from "element-plus";
import { onBeforeMount, ref, watch } from "vue";
import PopupWindow from "@/core/popup/components/PopupWindow.vue";
import JsonTreeView from "@/flow/components/json-tree-view/JsonTreeView.vue";
import i18n from "@/core/i18n/i18n";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";


export default /*#__PURE__*/_defineComponent({
  __name: 'DataMapperDialog',
  props: {
    dialog: { type: Boolean },
    index: {},
    outputData: {},
    nextStepOutputData: {},
    savedMap: {},
    moved: { type: Boolean }
  },
  emits: ["close", "save"],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

const props = __props;

const path = ref("path");
const objectMap = ref(new Map());
const selectedMapElement = ref({
  key: "key",
  value: "value",
});

const mapOne = ref();
const mapTwo = ref();

const result = ref<HTMLElement>();

const parent = document.getElementById("content");

const scrollHeight = ref(parent ? (4 * parent.clientHeight) / 6 - 260 : 470);

const initValueOne = ref(0);
const initValueTwo = ref(0);

const keyListOne = ref([]);
const keyListTwo = ref([]);

const objectOne = ref({});
const objectTwo = ref({});

const loadingOne = ref(false);
const loadingTwo = ref(false);

const emit = __emit;

function selectElement(event) {
  selectedMapElement.value = {
    key: "key",
    value: "value",
  };
  path.value = event.path;
}

function mapObjects(event) {
  if (path.value !== "path") {
    objectMap.value.set(path.value, {
      value: event.path,
      color: `hsl(${360 * Math.random()},${25 + 70 * Math.random()}%,${
        85 + 10 * Math.random()
      }%)`,
    });
  }
  path.value = "path";
}

function selectMapElement(key, value) {
  const scrollOne = document.getElementById(`item-${key}-1`).offsetTop;
  const scrollTwo = document.getElementById(`item-${value.value}-2`).offsetTop;

  if (scrollOne < 250 && scrollTwo > 250) {
    mapOne.value.setScrollTop(scrollOne - 250);
    mapTwo.value.setScrollTop(scrollTwo - (250 - (250 - scrollOne)));
  } else if (scrollOne > 250 && scrollTwo < 250) {
    mapOne.value.setScrollTop(scrollOne - (250 - (250 - scrollTwo)));
    mapTwo.value.setScrollTop(scrollTwo - 250);
  } else if (scrollOne < 250 && scrollTwo < 250) {
    mapOne.value.setScrollTop(scrollOne);
    mapTwo.value.setScrollTop(scrollTwo);
  } else {
    mapOne.value.setScrollTop(scrollOne - 250);
    mapTwo.value.setScrollTop(scrollTwo - 250);
  }

  selectedMapElement.value.key = key;
  selectedMapElement.value.value = value.value;
}

function removeObjectMapping(key) {
  if (selectedMapElement.value.key === key) {
    selectedMapElement.value = {
      key: "key",
      value: "value",
    };
  }
  objectMap.value.delete(key);
}

function updateScrollHeight(newHeight) {
  scrollHeight.value = newHeight - 30;
}

function convertToLazyLoadOne() {
  if (props.outputData) {
    let jsonString = props.outputData;

    // Encapsulating numeric values inside double quotes just for UI representation.
    jsonString = jsonString.replace(
      /(?<=:\s|,\s|^\s?)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,}\]\s])/g,
      (match) => `"${match}"`
    );
    jsonString = jsonString.replace(
      /(?<=\[\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,\]\s])/g,
      (match) => `"${match}"`
    );
    jsonString = jsonString.replace(
      /(?<=,\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,\]\s])/g,
      (match) => `"${match}"`
    );

    try {
      const json = JSON.parse(jsonString);
      keyListOne.value = Object.keys(json);
      keyListOne.value
        .slice(initValueOne.value, initValueOne.value + 15)
        .forEach((key) => {
          objectOne.value[key] = json[key];
        });
      objectOne.value = JSON.stringify(objectOne.value);
      initValueOne.value += 15;
    } catch (error) {
      console.error("JSON parse error in convertToLazyLoadOne:", error);
    }
  }
}

function convertToLazyLoadTwo() {
  if (props.nextStepOutputData) {
    let jsonString = props.nextStepOutputData;

    // Encapsulating numeric values inside double quotes just for UI representation.
    jsonString = jsonString.replace(
      /(?<=:\s|,\s|^\s?)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,}\]\s])/g,
      (match) => `"${match}"`
    );
    jsonString = jsonString.replace(
      /(?<=\[\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,\]\s])/g,
      (match) => `"${match}"`
    );
    jsonString = jsonString.replace(
      /(?<=,\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,\]\s])/g,
      (match) => `"${match}"`
    );

    try {
      const json = JSON.parse(jsonString);
      keyListTwo.value = Object.keys(json);
      keyListTwo.value
        .slice(initValueTwo.value, initValueTwo.value + 15)
        .forEach((key) => {
          objectTwo.value[key] = json[key];
        });
      objectTwo.value = JSON.stringify(objectTwo.value);
      initValueTwo.value += 15;
    } catch (error) {
      console.error("JSON parse error in convertToLazyLoadTwo:", error);
    }
  }
}
function addItemToObjectOne() {
  if (props.outputData) {
    let jsonString = props.outputData;

    // Encapsulating numeric values inside double quotes just for UI representation.
    jsonString = jsonString.replace(
      /(?<=:\s|,\s|^\s?)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,}\]\s])/g,
      (match) => `"${match}"`
    );
    jsonString = jsonString.replace(
      /(?<=\[\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,\]\s])/g,
      (match) => `"${match}"`
    );
    jsonString = jsonString.replace(
      /(?<=,\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,\]\s])/g,
      (match) => `"${match}"`
    );

    try {
      const json = JSON.parse(jsonString);
      const copyObject = JSON.parse(objectOne.value as string);
      keyListOne.value
        .slice(initValueOne.value, initValueOne.value + 15)
        .forEach((key) => {
          copyObject[key] = json[key];
        });
      objectOne.value = JSON.stringify(copyObject);
      initValueOne.value += 15;
    } catch (error) {
      console.error("JSON parse error in addItemToObjectOne:", error);
    }
  }
}
function addItemToObjectTwo() {
  if (props.nextStepOutputData) {
    let jsonString = props.nextStepOutputData;

    // Encapsulating numeric values inside double quotes just for UI representation.
    jsonString = jsonString.replace(
      /(?<=:\s|,\s|^\s?)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,}\]\s])/g,
      (match) => `"${match}"`
    );
    jsonString = jsonString.replace(
      /(?<=\[\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,\]\s])/g,
      (match) => `"${match}"`
    );
    jsonString = jsonString.replace(
      /(?<=,\s*)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,\]\s])/g,
      (match) => `"${match}"`
    );

    try {
      const json = JSON.parse(jsonString);
      const copyObject = JSON.parse(objectTwo.value as string);
      keyListTwo.value
        .slice(initValueTwo.value, initValueTwo.value + 15)
        .forEach((key) => {
          copyObject[key] = json[key];
        });
      objectTwo.value = JSON.stringify(copyObject);
      initValueTwo.value += 15;
    } catch (error) {
      console.error("JSON parse error in addItemToObjectTwo:", error);
    }
  }
}
function scrollOfOne(event) {
  const screenOne = document.getElementById("screen-one");
  const distanceToBottomOne = screenOne
    ? event.scrollTop + scrollHeight.value - screenOne.offsetHeight
    : -1;
  if (distanceToBottomOne >= 0 && !loadingOne.value) {
    loadingOne.value = true;
    setTimeout(() => {
      addItemToObjectOne();
      loadingOne.value = false;
    }, 500);
  }
}

function scrollOfTwo(event) {
  const screenTwo = document.getElementById("screen-two");
  const distanceToBottomTwo = screenTwo
    ? event.scrollTop + scrollHeight.value - screenTwo.offsetHeight
    : -1;
  if (distanceToBottomTwo >= 0 && !loadingOne.value) {
    loadingTwo.value = true;
    setTimeout(() => {
      addItemToObjectTwo();
      loadingTwo.value = false;
    }, 500);
  }
}

watch(
  () => scrollHeight.value,
  () => {
    const screenOne = document.getElementById("screen-one");
    if (screenOne) {
      if (
        screenOne.offsetHeight <= scrollHeight.value &&
        !loadingOne.value &&
        keyListOne.value.length >= initValueOne.value + 15
      ) {
        loadingOne.value = true;
        setTimeout(() => {
          addItemToObjectOne();
          loadingOne.value = false;
        }, 500);
      }
    }
    const screenTwo = document.getElementById("screen-two");
    if (screenTwo) {
      if (
        screenTwo.offsetHeight <= scrollHeight.value &&
        !loadingTwo.value &&
        keyListTwo.value.length >= initValueTwo.value + 15
      ) {
        loadingTwo.value = true;
        setTimeout(() => {
          addItemToObjectTwo();
          loadingTwo.value = false;
        }, 500);
      }
    }
  }
);

onBeforeMount(() => {
  if (props.savedMap) {
    props.savedMap.forEach((value) => {
      const list = value.toString().split("=>");
      objectMap.value.set(list[0], {
        value: list[1],
        color: `hsl(${360 * Math.random()},${25 + 70 * Math.random()}%,${
          85 + 10 * Math.random()
        }%)`,
      });
    });
  }
  convertToLazyLoadOne();
  convertToLazyLoadTwo();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PopupWindow, {
      dialog: _ctx.dialog,
      size: 'm',
      live: 0,
      fixed: false,
      "fixed-height": false,
      lazyLoad: false,
      moved: _ctx.moved,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close'))),
      onUpdateHeight: _cache[2] || (_cache[2] = ($event: any) => (updateScrollHeight($event)))
    }, {
      "header-label": _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("Flow.DataMapper")), 1)
      ]),
      main: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.index) + ". " + _toDisplayString(_unref(t)("Flow.StepsOutputData")), 1),
            _createVNode(_unref(ElScrollbar), {
              height: scrollHeight.value.toString() + 'px',
              ref_key: "mapOne",
              ref: mapOne,
              onScroll: scrollOfOne
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(JsonTreeView, {
                    data: objectOne.value,
                    objectMap: objectMap.value,
                    path: path.value,
                    id: "raw",
                    element: selectedMapElement.value,
                    tab: 1,
                    searchable: true,
                    "search-data": props.outputData,
                    onSelected: selectElement,
                    style: {"width":"100%"}
                  }, null, 8, ["data", "objectMap", "path", "element", "search-data"])
                ])
              ]),
              _: 1
            }, 8, ["height"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.index + 1) + ". " + _toDisplayString(_unref(t)("Flow.StepsOutputData")), 1),
            _createVNode(_unref(ElScrollbar), {
              height: scrollHeight.value.toString() + 'px',
              ref_key: "mapTwo",
              ref: mapTwo,
              onScroll: scrollOfTwo
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(JsonTreeView, {
                    data: objectTwo.value,
                    onSelected: mapObjects,
                    tab: 2,
                    element: selectedMapElement.value,
                    objectMap: objectMap.value,
                    searchable: true,
                    "search-data": props.nextStepOutputData,
                    style: {"width":"100%"}
                  }, null, 8, ["data", "element", "objectMap", "search-data"])
                ])
              ]),
              _: 1
            }, 8, ["height"])
          ])
        ]),
        (objectMap.value.size > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref_key: "result",
              ref: result,
              style: {"width":"100%","margin-top":"20px","overflow-wrap":"break-word"}
            }, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(objectMap.value, ([key, value]) => {
                return (_openBlock(), _createBlock(_unref(ElTag), {
                  style: {"margin":"5px","cursor":"pointer","color":"black"},
                  key: key,
                  closable: "",
                  onClose: ($event: any) => (removeObjectMapping(key)),
                  onClick: ($event: any) => (selectMapElement(key, value)),
                  size: "small",
                  color: value.color
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(key) + " => " + _toDisplayString(value.value), 1)
                  ]),
                  _: 2
                }, 1032, ["onClose", "onClick", "color"]))
              }), 128))
            ], 512))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
            alt: "Loading...",
            class: "loader-logo-40"
          }, null, 8, _hoisted_9)
        ], 512), [
          [_vShow, loadingOne.value || loadingTwo.value]
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(ElButton), {
          class: "btn-oneTeg2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('save', objectMap.value)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("Common.Save")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["dialog", "moved"])
  ], 512))
}
}

})